<template>
  <div class="page-warpper">
    <div class="main-content">
      <div class="top">
        <div class="msg">
          <img
            class="avatar"
            v-if="userInfo.photoPath"
            :src="userInfo.headUrl"
          />
          <img
            class="avatar"
            v-else
            src="../assets/images/default-header.png"
          />
          <div class="msg-content">
            爪玩是一个非常有趣的平台，快来加入吧！
          </div>
        </div>
        <div class="join" @click="join">立即加入</div>
      </div>
      <div class="part" v-for="(item, index) in cntImgList" :key="index">
        <img :src="item.image" />
      </div>
    </div>
    <div class="align">
      <div class="warpper">
        <div class="align-content">
          Copyright © {{new Date().getFullYear()}} 爪玩 All Rights Reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfoById } from '@/service/api'
import { getUrlParams } from '@/utils'

export default {
  data() {
    return {
      userInfo: '',
      cntImgList: [
        { image: require('../assets/images/bg_pic1.png') },
        { image: require('../assets/images/bg_pic2.png') },
        { image: require('../assets/images/bg_pic3.png') },
        { image: require('../assets/images/bg_pic4.png') },
        { image: require('../assets/images/bg_pic5.png') },
        { image: require('../assets/images/bg_pic6.png') },
        { image: require('../assets/images/bg_pic7.png') },
        { image: require('../assets/images/bg_pic8.png') },
      ],
    }
  },
  mounted() {
    this.getUserInfoById()
  },
  methods: {
    async getUserInfoById() {
      const params = {
        memberId: getUrlParams('id'),
      }
      const res = await getUserInfoById(params)
      if (res) {
        this.userInfo = res
        document.title = `【${res.nickname}】邀请您加入爪玩`
      }
    },
    join(){
      window.location.href = 'https://zw.pian-ai.com'
    },
  },
}
</script>

<style lang="less" scoped>
.page-warpper {
  height: 100%;
  background: #f57f20;
  .load-tab {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    .left {
      margin-left: 15px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #fff;
      .image-warpper {
        background: #fff;
        border-radius: 4px;
        text-align: center;
        margin-right: 10px;
        img {
          width: 22px;
          height: 22px;
          overflow: hidden;
          margin: 5px;
          display: block;
        }
      }
    }
    .load-btn {
      width: 60px;
      height: 25px;
      text-align: center;
      line-height: 25px;
      background: #f57f20;
      color: #fff;
      border-radius: 30px;
      margin-right: 15px;
      font-size: 12px;
    }
  }
  .main-content {
    .top {
      background-image: url('../assets/images/top_bg.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: 100% 100%;
      padding: 20px 12px 30px 12px;
      .msg {
        display: flex;
        align-items: flex-start;
        margin: 30px 0;
        .avatar {
          width: 50px;
          height: 50px;
          border-radius: 25px;
          overflow: hidden;
        }
        .msg-content {
          margin-left: 20px;
          flex: 1;
          color: @primaryTextColor;
          font-size: 18px;
          background: #fff;
          padding: 20px 15px;
          font-weight: 600;
          border-radius: 8px;
          line-height: 1.55;
          position: relative;
          box-shadow: 0 2px 6px 3px rgba(0, 0, 0, 0.1);
          max-width: 70%;
          &::after {
            content: '';
            position: absolute;
            top: 10px;
            left: -10px;
            border-bottom: 9px solid transparent;
            border-top: 9px solid transparent;
            border-right: 14px solid #fff;
          }
        }
      }
      .join{
        font-size: 18px;
        font-weight: 700;
        color: #f57f20;
        background-color: #fff;
        padding: 10px 30px;
        border-radius: 30px;
        text-align: center;
        margin: 0 30px;
      }
    }
    .part {
      width: 100%;
      padding: 0 12px;
      background: #f57f20;
      img {
        width: 100%;
        height: auto;
        object-fit: fill;
      }
    }
  }
  .align {
    background: #f57f20;
    padding-bottom: 30px;
    .warpper {
      padding: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      .align-content {
        color: #fff;
        font-size: 12px;
      }
    }
  }
}
</style>
